/* ============================================================
   pm-search-overlay.js
   Behaviour on top of the legacy open/close handling (which lives in
   collection.js / home.js and toggles #predictive-search.active):

   - Track recent searches in localStorage; show them in the
     "Your recent searches" column when the overlay opens.
   - Push the submitted query into recent history on form submit.
   - Wire the new Close button + ESC key to remove .active.
   - Wire the clear button to empty the input.
   ============================================================ */
(function(){
  var overlay = document.getElementById('predictive-search');
  if (!overlay || !overlay.classList.contains('pm-search-overlay')) return;

  var STORAGE_KEY = 'pm_recent_searches_v1';
  var MAX_RECENT  = 5;

  var form    = overlay.querySelector('#predictive-search-form');
  var input   = overlay.querySelector('#predictive-search-input');
  var clearBtn= overlay.querySelector('[data-ov-clear]');
  var closeBtn= overlay.querySelector('[data-ov-close]');
  var recentWrap = overlay.querySelector('[data-ov-recent-wrap]');
  var recentList = overlay.querySelector('[data-ov-recent]');
  var clearHistBtn = overlay.querySelector('[data-ov-clear-history]');
  var body    = overlay.querySelector('.ov-body');
  var curatedHTML = body ? body.innerHTML : '';   /* snapshot for restore */
  var fetchTimer = null;
  var lastQuery = '';

  function readRecent(){
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch(e){ return []; }
  }
  function writeRecent(arr){
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(arr)); } catch(e){}
  }
  function pushRecent(term){
    term = (term || '').trim();
    if (!term) return;
    var list = readRecent().filter(function(t){ return t.toLowerCase() !== term.toLowerCase(); });
    list.unshift(term);
    if (list.length > MAX_RECENT) list = list.slice(0, MAX_RECENT);
    writeRecent(list);
  }

  function escapeHtml(s){
    return String(s).replace(/[&<>"']/g, function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }

  function renderRecent(){
    if (!recentList || !recentWrap) return;
    var list = readRecent();
    if (!list.length){
      recentWrap.hidden = true;
      recentList.innerHTML = '';
      return;
    }
    recentWrap.hidden = false;
    recentList.innerHTML = list.map(function(term){
      var safe = escapeHtml(term);
      var qs = '?q=' + encodeURIComponent(term) + '&type=product,article';
      return '<a class="ov-row recent" href="/search' + qs + '">'
        + '<span class="n" aria-hidden="true">↻</span>'
        + '<div class="body">' + safe + '</div>'
        + '</a>';
    }).join('');
  }

  /* Re-render recent list whenever the overlay is opened. Legacy JS
     toggles `.active` so we observe class changes. */
  var observer = new MutationObserver(function(){
    if (overlay.classList.contains('active')) renderRecent();
  });
  observer.observe(overlay, { attributes:true, attributeFilter:['class'] });
  renderRecent();

  /* Capture the term on submit so it shows next time. */
  if (form){
    form.addEventListener('submit', function(){
      if (input) pushRecent(input.value);
    });
  }

  /* Clear input button — empty the field, restore curated body. */
  if (clearBtn && input){
    clearBtn.addEventListener('click', function(){
      input.value = '';
      restoreCurated();
      input.focus();
    });
  }

  /* ============================================================
     LIVE SEARCH — empty input shows the curated 3-column layout
     (Recent · Trending · Hero). Typing >= 1 char replaces the body
     with results from /search?view=json (templates/search.json.liquid).
     That endpoint already filters GWP products + returns price/image,
     so we don't duplicate any logic.
     ============================================================ */
  function restoreCurated(){
    if (!body) return;
    body.innerHTML = curatedHTML;
    /* Re-resolve recent refs since we just rewrote .ov-body */
    recentWrap = overlay.querySelector('[data-ov-recent-wrap]');
    recentList = overlay.querySelector('[data-ov-recent]');
    clearHistBtn = overlay.querySelector('[data-ov-clear-history]');
    bindClearHistory();
    renderRecent();
    lastQuery = '';
  }

  function bindClearHistory(){
    if (!clearHistBtn) return;
    clearHistBtn.addEventListener('click', function(e){
      e.preventDefault();
      writeRecent([]);
      renderRecent();
    });
  }

  function escapeAttr(s){ return escapeHtml(s); }

  function renderResults(term, data){
    if (!body) return;
    var safeTerm = escapeHtml(term);
    var count = (data && data.results_count) || 0;
    var results = (data && data.results) || [];

    if (count === 0 || results.length === 0){
      body.innerHTML =
        '<div class="ov-results-head"><h4>No matches for "' + safeTerm + '"</h4>'
        + '<p class="ov-results-sub">Try a broader term — or hit Enter to see articles too.</p></div>';
      return;
    }

    function fmtMoney(minor){
      if (typeof window.numberToMoney === 'function') return window.numberToMoney(minor / 100);
      return '€' + (minor / 100).toFixed(2);
    }

    var cardsHtml = results.slice(0, 8).map(function(r){
      /* Canonical .product-card from sections/pnm-collection-grid.liquid */
      var heart =
        '<button type="button" class="heart" aria-label="Save" aria-pressed="false"'
          + ' data-pnm-wishlist data-product-handle="' + escapeAttr(r.handle || '') + '"'
          + ' onclick="event.preventDefault();event.stopPropagation();">'
          + '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">'
          + '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>'
          + '</svg></button>';
      var priceMinorForBadge = r.priceMin || r.price || 0;
      var ribbon = '';
      var hasCompare = r.compareAtPrice && r.compareAtPrice > priceMinorForBadge;
      /* sale_ribbon_rule match (via templates/search.json.liquid) wins
         over the manual badge, matching the Liquid card priority. */
      if (hasCompare && r.saleStyle === 'savings') {
        var saveMinor = r.compareAtPrice - priceMinorForBadge;
        var prefix = r.salePrefix || 'SAVE';
        ribbon = '<span class="ribbon ribbon--sale">' + escapeHtml(prefix) + ' ' + fmtMoney(saveMinor) + '</span>';
      } else if (r.badge) {
        ribbon = '<span class="ribbon">' + escapeHtml(r.badge) + '</span>';
      } else if (hasCompare) {
        var pctOff = Math.round((r.compareAtPrice - priceMinorForBadge) * 100 / r.compareAtPrice);
        ribbon = '<span class="ribbon ribbon--sale">' + pctOff + '% OFF</span>';
      }
      var img = r.image
        ? '<img class="img-default" src="' + escapeAttr(r.image) + '" alt="' + escapeAttr(r.title || '') + '" loading="lazy">'
        : '';
      var img2 = r.image2
        ? '<img class="img-hover" src="' + escapeAttr(r.image2) + '" alt="' + escapeAttr(r.title || '') + '" loading="lazy">'
        : '';
      /* Hover video — custom.hover_video. Rendered with preload="none"
         so nothing downloads until the card is actually hovered; the
         pnmHoverVideo loader in pnm-v4.js sets .src on mouseenter. */
      var vid = r.video
        ? '<video class="vid-hover" data-hover-video-src="' + escapeAttr(r.video) + '" muted loop playsinline preload="none" aria-hidden="true" width="720" height="720"></video>'
        : '';
      /* Coming Soon — product.type == "Coming soon" overrides the ATC
         button and hides the price under the title. */
      var isComingSoon = r.comingSoon === true;
      var subtitle = r.subtitle ||
        ((r.title && r.title.indexOf(' - ') > -1) ? r.title.split(' - ').slice(1).join(' - ') : '');
      var name = (r.subtitle ? r.title : (subtitle ? r.title.split(' - ')[0] : r.title));
      var priceMinor = r.priceMin || r.price || 0;
      var priceHtml = '<span class="pnm-product-price"><span class="pnm-price-now">' + fmtMoney(priceMinor) + '</span>';
      if (r.compareAtPrice && r.compareAtPrice > priceMinor){
        priceHtml += '<span class="pnm-price-was">' + fmtMoney(r.compareAtPrice) + '</span>';
      }
      priceHtml += '</span>';
      var reviewsHtml = '';
      if (r.rating){
        reviewsHtml = '<span class="reviews"><span class="stars">★★★★★</span>'
          + escapeHtml(String(r.rating)) + ' (' + (r.ratingCount || 0) + ')</span>';
      }
      var ribbonOut = isComingSoon ? '<span class="ribbon">Coming soon</span>' : ribbon;
      var ctaOut = isComingSoon
        ? '<button class="quick-add quick-add--coming-soon" type="button" disabled aria-disabled="true">Coming soon</button>'
        : '';
      var metaOut = isComingSoon
        ? ''
        : '<div class="meta"><span class="price">' + priceHtml + '</span>' + reviewsHtml + '</div>';
      return ''
        + '<a class="product-card" href="' + escapeAttr(r.url || '#') + '">'
          + '<div class="media">'
            + heart
            + ribbonOut
            + img
            + img2
            + vid
            + ctaOut
          + '</div>'
          + (subtitle ? '<p class="code">' + escapeHtml(subtitle) + '</p>' : '')
          + '<h3 class="name">' + escapeHtml(name) + '</h3>'
          + metaOut
        + '</a>';
    }).join('');

    var seeAllHref = '/search?q=' + encodeURIComponent(term) + '&type=product,article';
    body.innerHTML =
      '<div class="ov-results-head">'
        + '<h4>' + count + ' result' + (count === 1 ? '' : 's') + ' for "' + safeTerm + '"</h4>'
        + '<a class="ov-results-link" href="' + seeAllHref + '">See all results →</a>'
      + '</div>'
      + '<div class="ov-results-wrap pnm-collection-grid"><div class="grid ov-results-grid">'
        + cardsHtml
      + '</div></div>';
  }

  function runSearch(term){
    var url = '/search?type=product&q=' + encodeURIComponent(term) + '*&view=json';
    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function(r){ if (!r.ok) throw new Error('search ' + r.status); return r.json(); })
      .then(function(data){
        if (input.value.trim().toLowerCase() !== term.toLowerCase()) return; /* stale */
        renderResults(term, data);
      })
      .catch(function(){ /* leave UI as-is on error */ });
  }

  if (input){
    input.addEventListener('input', function(){
      var term = input.value.trim();
      if (fetchTimer) clearTimeout(fetchTimer);
      if (!term){
        restoreCurated();
        return;
      }
      if (term === lastQuery) return;
      lastQuery = term;
      fetchTimer = setTimeout(function(){ runSearch(term); }, 200);
    });
  }

  bindClearHistory();

  /* New Close button — defer to legacy toggle. */
  if (closeBtn){
    closeBtn.addEventListener('click', function(){
      overlay.classList.remove('active');
    });
  }

  /* ESC to close. */
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && overlay.classList.contains('active')){
      overlay.classList.remove('active');
    }
  });

  /* Header "Search" link — intercept to open the overlay instead of
     navigating to /search. Falls through (no preventDefault) if the
     user holds a modifier so middle-click / cmd-click still opens in
     a new tab as a normal navigation. */
  document.querySelectorAll('[data-pm-search-toggle]').forEach(function(btn){
    btn.addEventListener('click', function(e){
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;
      e.preventDefault();
      overlay.classList.add('active');
      if (input) setTimeout(function(){ input.focus({ preventScroll: true }); }, 50);
    });
  });

  /* Mobile menu search bar — tapping the input closes the menu and
     opens the v4 overlay so users get the same curated/live-results UX
     as desktop. */
  var mobileSearchInputs = document.querySelectorAll('.pnm-mm-search input[type="search"], .pnm-mm-search input[name="q"]');
  mobileSearchInputs.forEach(function(mInput){
    mInput.addEventListener('focus', openFromMobile);
    mInput.addEventListener('click', openFromMobile);
  });
  function openFromMobile(e){
    e.preventDefault();
    e.target.blur();
    var mobileMenu = document.getElementById('pnm-mobile-menu');
    if (mobileMenu) mobileMenu.classList.remove('active');
    overlay.classList.add('active');
    if (input) setTimeout(function(){ input.focus({ preventScroll: true }); }, 200);
  }

})();
